import { cx } from '@/lib/cx';
import styles from './HeroWaveEdge.module.css';

export interface HeroWaveEdgeProps {
  className?: string;
}

/**
 * Borde ondulado que cierra el hero de México sobre el crema del manifiesto.
 *
 * NO es el arco marcado de Cancún: aquí la sagitta medida es de ~25 px sobre
 * 1024 (2,4 %), una onda muy tendida con dos vientres. Por eso no se usa
 * `CurveDivider` del substrato, cuyo trazado es la ese profunda del hub.
 */
export function HeroWaveEdge({ className }: HeroWaveEdgeProps) {
  return (
    <svg
      className={cx(styles.edge, className)}
      viewBox="0 0 1440 64"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        className={styles.fill}
        d="M0 30 C 300 62, 560 6, 860 22 C 1120 36, 1280 58, 1440 34 L1440 64 L0 64 Z"
      />
    </svg>
  );
}
